<template>
  <div>
    <HeaderBar />
    <div class="attendance-main">
      <div class="name-area">
        <div class="name-display">
          <span v-if="selectedStudent">{{ selectedStudent.username }}</span>
          <span v-else>请点名</span>
        </div>
        <input
          v-model="question"
          class="question-input"
          type="text"
          placeholder="请输入问题"
          :disabled="calling || loading"
        />
        <el-input-number
          v-model="score"
          :min="0"
          :max="10"
          :step="1"
          :disabled="calling || loading"
          class="score-input"
          style="margin: 0 12px; width: 100px;"
        />
        <label class="correct-label">
          <!-- 选择就是1 未选择就是0 -->
          <input type="checkbox" v-model="status" :true-value="1" :false-value="0" :disabled="calling || loading" />
        </label>
      </div>
      <div class="btn-row">
        <button class="random-btn" :disabled="calling || loading" @click="startRandomCall">{{ calling ? '正在点名...' : '随机点名' }}</button>
        <button class="save-btn" :disabled="calling || loading || !selectedStudent || !question" @click="saveCalled">保存</button>
        <button class="record-btn" @click="showRecordDialog = true">记录</button>
        <button class="seatmap-btn" @click="goToSeatMap">座位表</button>
      </div>
      <el-dialog v-model="showRecordDialog" title="点名记录" width="90vw" :close-on-click-modal="true">
        <div class="record-search-bar">
          <el-input v-model="recordKeyword" placeholder="请输入关键字" class="record-search-input" size="small" style="width: 200px;" @keyup.enter="fetchRecords" />
          <el-button type="primary" size="small" @click="fetchRecords">搜索</el-button>
        </div>
        <div v-if="recordLoading" class="loading">加载中...</div>
        <el-table v-else :data="recordList" style="width: 100%">
          <el-table-column prop="id" label="ID" width="60" />
          <el-table-column prop="username" label="姓名" width="100" />
          <el-table-column prop="school" label="学校" width="180" />
          <el-table-column prop="question" label="问题" />
          <el-table-column prop="score" label="分数" width="80" />
          <el-table-column prop="createTime" label="时间" width="160" />
          <el-table-column label="状态" width="80">
            <template #default="scope">
              <span v-if="scope.row.status == 1" class="ok-status">ok</span>
              <span v-else class="error-status">Error</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" v-if="isAdmin">
            <template #default="scope">
              <el-button type="danger" size="small" @click="deleteRecord(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      
      <!-- 删除确认对话框 -->
      <el-dialog v-model="deleteDialogVisible" title="确认删除" width="400px" :close-on-click-modal="false">
        <div class="delete-confirm-content">
          <p>确定要删除这条记录吗？</p>
          <p class="delete-record-info" v-if="recordToDelete">
            学生：{{ recordToDelete.username }} | 问题：{{ recordToDelete.question }}
          </p>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="deleteDialogVisible = false">取消</el-button>
            <el-button type="danger" @click="confirmDelete" :loading="deleteLoading">确认删除</el-button>
          </span>
        </template>
      </el-dialog>
      <div v-if="loading" class="loading">加载中...</div>
      <div v-else class="student-list">
        <div class="seatmap-main">
          <div class="seatmap-side">
            <div v-for="row in 10" :key="'L'+row" class="seat-row">
              <button
                v-for="col in 6"
                :key="'L'+row+'-'+col"
                class="student-btn"
                :class="[
                  { selected: selectedStudent && selectedStudent.userId === getStudentBySeat((row-1)*6+col-1)?.userId,
                    called: calledIds.includes(getStudentBySeat((row-1)*6+col-1)?.userId)
                  },
                  getBtnColor(getStudentBySeat((row-1)*6+col-1)?.recordCount)
                ]"
                :style="getStudent((row-1)*6+col-1).groupId ? { borderColor: groupColors[(getStudent((row-1)*6+col-1).groupId-1)%groupColors.length], borderWidth: '3px', borderStyle: 'solid' } : {}"
                @click="callStudent(getStudentBySeat((row-1)*6+col-1))"
              >
                <template v-if="getStudent((row-1)*6+col-1).username">
                  <span>{{ getStudent((row-1)*6+col-1).username }}({{ getStudent((row-1)*6+col-1).recordCount }})</span>
                  <span v-if="getStudent((row-1)*6+col-1).groupLeader === 1"> 👑</span>
                </template>
              </button>
            </div>
          </div>
          <div class="seatmap-side">
            <div v-for="row in 10" :key="'R'+row" class="seat-row">
              <button
                v-for="col in 6"
                :key="'R'+row+'-'+col"
                class="student-btn"
                :class="[
                  { selected: selectedStudent && selectedStudent.userId === getStudentBySeat(60+(row-1)*6+col-1)?.userId,
                    called: calledIds.includes(getStudentBySeat(60+(row-1)*6+col-1)?.userId)
                  },
                  getBtnColor(getStudentBySeat(60+(row-1)*6+col-1)?.recordCount)
                ]"
                :style="getStudent(60+(row-1)*6+col-1).groupId ? { borderColor: groupColors[(getStudent(60+(row-1)*6+col-1).groupId-1)%groupColors.length], borderWidth: '3px', borderStyle: 'solid' } : {}"
                @click="callStudent(getStudentBySeat(60+(row-1)*6+col-1))"
              >
                <template v-if="getStudent(60+(row-1)*6+col-1).username">
                  <span>{{ getStudent(60+(row-1)*6+col-1).username }}({{ getStudent(60+(row-1)*6+col-1).recordCount }})</span>
                  <span v-if="getStudent(60+(row-1)*6+col-1).groupLeader === 1"> 👑</span>
                </template>
              </button>
            </div>
          </div>
        </div>
        <div class="platform-box">讲台</div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '@/components/HeaderBar.vue';
import { getUserList, addAttendanceRecord, getRecordsList, deleteRecord } from '@/api/index.js';

export default {
  name: 'AttendancePage',
  components: { HeaderBar },
  data() {
    return {
      students: [],
      loading: true,
      selectedStudent: null,
      calling: false,
      timer: null,
      calledIds: [],
      question: '',
      status: 0,
      score: 1,
      showRecordDialog: false,
      recordList: [],
      recordLoading: false,
      recordKeyword: '',
      isAdmin: false,
      deleteDialogVisible: false,
      recordToDelete: null,
      deleteLoading: false,
      groupColors: [
        '#e53935', // 红
        '#8e24aa', // 紫
        '#3949ab', // 蓝
        '#039be5', // 天蓝
        '#00897b', // 青
        '#43a047', // 绿
        '#fbc02d', // 黄
        '#fb8c00', // 橙
        '#6d4c41', // 棕
        '#d81b60', // 粉
        '#1e88e5', // 深蓝
        '#00acc1', // 湖蓝
        '#7cb342', // 浅绿
        '#f4511e', // 深橙
        '#757575', // 灰
        '#c62828', // 深红
        '#ad1457', // 深粉
        '#283593', // 靛蓝
        '#00838f', // 深青
        '#2e7d32'  // 深绿
      ],
    };
  },
  watch: {
    showRecordDialog(val) {
      if (val) {
        this.fetchRecords();
      }
    }
  },
  async mounted() {
    this.getStudentList();
    this.checkAdmin();
  },
  methods: {
    async getStudentList() {
      this.loading = true;
      try {
        const res = await getUserList();
        if (res.code === '000000') {
          // seatNo>0的学生按seatNo排到对应座位
          const seats = Array(120).fill(null);
          const noSeat = [];
          res.data.forEach(s => {
            if (s.seatNo && s.seatNo > 0 && s.seatNo <= 120) {
              seats[s.seatNo - 1] = s;
            } else {
              noSeat.push(s);
            }
          });
          // seatNo=0或未定义的学生顺序补到空位
          let idx = 0;
          for (let i = 0; i < seats.length; i++) {
            if (!seats[i] && idx < noSeat.length) {
              seats[i] = noSeat[idx];
              seats[i].seatNo = i + 1;
              idx++;
            }
          }
          this.students = seats;
        }
      } finally {
        this.loading = false;
      }
    },
    async fetchRecords() {
      this.recordLoading = true;
      try {
        const res = await getRecordsList(this.recordKeyword);
        if (res.code === '000000') {
          this.recordList = res.data;
        }
      } finally {
        this.recordLoading = false;
      }
    },
    startRandomCall() {
      if (this.calling || this.students.length === 0) return;
      this.calling = true;
      let count = 0;
      const duration = 3000; // 3秒
      const interval = 80; // 名字切换速度
      this.timer && clearInterval(this.timer);
      this.timer = setInterval(() => {
        const idx = Math.floor(Math.random() * this.students.length);
        this.selectedStudent = this.students[idx];
        count += interval;
        if (count >= duration) {
          clearInterval(this.timer);
          this.calling = false;
          // 记录已点名
          if (!this.calledIds.includes(this.selectedStudent.userId)) {
            this.calledIds.push(this.selectedStudent.userId);
          }
        }
      }, interval);
    },
    callStudent(student) {
      if (this.calling) return;
      this.selectedStudent = student;
      if (!this.calledIds.includes(student.userId)) {
        this.calledIds.push(student.userId);
      }
    },
    saveCalled() {
      if (!this.selectedStudent || !this.question) return;
      const record = {
        userId: this.selectedStudent.userId,
        username: this.selectedStudent.username,
        question: this.question,
        status: this.status,
        score: this.score,
      };
      // 网络请求保存
      addAttendanceRecord(record)
        .then(() => {
          this.$message.success('保存成功！');
          // 清空输入
          this.question = '';
          this.status = 0;
          this.score = 1;
          // 重新获取学生列表
          this.getStudentList();
        })
        .catch(() => {
          this.$message.error('保存失败，请重试！');
        });
    },
    getBtnColor(count) {
      if (!count || count === 0) return 'btn-gray';
      if (count === 1) return 'btn-green';
      if (count === 2) return 'btn-blue';
      if (count === 3) return 'btn-orange';
      if (count === 4) return 'btn-red';
      return 'btn-purple'; // 5次及以上
    },
    checkAdmin() {
      // 从store中获取用户信息并检查角色
      const userInfo = this.$store.getters.userInfo;
      this.isAdmin = userInfo && userInfo.role === 2;
    },
    deleteRecord(record) {
      this.recordToDelete = record;
      this.deleteDialogVisible = true;
    },
    confirmDelete() {
      if (!this.recordToDelete) return;
      
      this.deleteLoading = true;
      deleteRecord(this.recordToDelete.id)
        .then(() => {
          this.$message.success('删除成功！');
          this.deleteDialogVisible = false;
          this.recordToDelete = null;
          // 重新获取记录列表
          this.fetchRecords();
        })
        .catch((error) => {
          this.$message.error('删除失败：' + error.message);
        })
        .finally(() => {
          this.deleteLoading = false;
        });
    },
    goToSeatMap() {
      this.$router.push('/seat-map');
    },
    getStudentName(idx) {
      if (this.students[idx]) {
        return this.students[idx].username+"("+this.students[idx].recordCount+")";
      }
      return '';
    },
    getStudent(idx) {
      return this.students[idx] || {};
    },
    getStudentBySeat(idx) {
      return this.students[idx] || null;
    },
  },
  beforeUnmount() {
    this.timer && clearInterval(this.timer);
  },
};
</script>

<style scoped>
.attendance-main {
  background: #e3effa;
  min-height: 90vh;
  padding: 24px;
}
.name-area {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-bottom: 16px;
}
.name-display {
  font-size: 2.2rem;
  font-weight: bold;
  min-width: 120px;
  color: #2c3e50;
  background: #fff;
  border-radius: 8px;
  padding: 16px 32px;
  box-shadow: 0 2px 8px #b3c6e0;
}
.question-input {
  font-size: 2.2rem;
  padding: 16px 32px;
  border-radius: 6px;
  border: 1px solid #bfc4c9;
  min-width: 500px;
  height: 50px;
}
.correct-label {
  display: flex;
  align-items: center;
  font-size: 1rem;
  gap: 4px;
  user-select: none;
}
.btn-row {
  display: flex;
  gap: 24px;
  margin-bottom: 2px;
}
.random-btn {
  font-size: 1.2rem;
  padding: 10px 28px;
  border-radius: 6px;
  background: #6fa8dc;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}
.random-btn:disabled {
  background: #bfc4c9;
  cursor: not-allowed;
}
.save-btn {
  font-size: 1.2rem;
  padding: 10px 28px;
  border-radius: 6px;
  background: #27ae60;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
}
.save-btn:disabled {
  background: #bfc4c9;
  cursor: not-allowed;
}
.record-btn {
  font-size: 1.2rem;
  padding: 10px 28px;
  border-radius: 6px;
  background: #f39c12;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  margin-left: 8px;
}
.seatmap-btn {
  font-size: 1.2rem;
  padding: 10px 28px;
  border-radius: 6px;
  background: #4fa3f7;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  margin-left: 8px;
}
.student-list {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.seatmap-main {
  display: flex;
  justify-content: center;
  gap: 60px;
  margin: 40px 0 0 0;
}
.seatmap-side {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.seat-row {
  display: flex;
  gap: 12px;
}
.student-btn {
  width: 90px;
  height: 40px;
  background: #bfc4c9;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  text-align: center;
}
.student-btn:empty {
  background: #e0e0e0;
  cursor: default;
}
.platform-box {
  margin: 48px auto 0 auto;
  padding: 14px 60px;
  border: 2px solid #4fa3f7;
  border-radius: 12px;
  background: #fff;
  color: #4fa3f7;
  font-size: 1.3rem;
  font-weight: bold;
  text-align: center;
  box-shadow: 0 2px 8px #b3c6e0;
}
.loading {
  text-align: center;
  font-size: 18px;
  color: #888;
  margin-top: 40px;
}
.btn-gray {
  background: #bfc4c9 !important;
}
.btn-green {
  background: #6fcf97 !important;
}
.btn-blue {
  background: #4fa3f7 !important;
}
.btn-orange {
  background: #f7b84f !important;
}
.btn-red {
  background: #f76f6f !important;
}
.btn-purple {
  background: #a259f7 !important;
}
.ok-status {
  color: #27ae60;
  font-weight: bold;
}
.error-status {
  color: #e74c3c;
  font-weight: bold;
}
.score-input {
  vertical-align: middle;
}
.record-search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.record-search-input {
  flex: none;
}
.delete-confirm-content {
  text-align: center;
  padding: 20px 0;
}
.delete-confirm-content p {
  margin: 10px 0;
  color: var(--el-text-color-primary);
}
.delete-record-info {
  color: var(--el-text-color-secondary) !important;
  font-size: 14px;
  background-color: var(--el-fill-color-light);
  padding: 10px;
  border-radius: 4px;
  margin-top: 15px !important;
}
@media (max-width: 900px) {
  .seatmap-main {
    flex-direction: column;
    gap: 24px;
    align-items: center;
  }
  .platform-box {
    padding: 10px 30px;
    font-size: 1.1rem;
  }
}
@media (max-width: 600px) {
  .attendance-main {
    padding: 8px;
    min-height: unset;
  }
  .name-area {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
    margin-bottom: 8px;
  }
  .name-display {
    font-size: 1.2rem;
    padding: 8px 12px;
    min-width: unset;
  }
  .question-input {
    font-size: 1rem;
    padding: 8px 12px;
    min-width: unset;
    width: 100%;
    height: 36px;
  }
  .score-input {
    width: 70px !important;
    margin: 0 4px;
  }
  .btn-row {
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
  }
  .random-btn,
  .save-btn,
  .record-btn,
  .seatmap-btn {
    font-size: 1rem;
    padding: 8px 0;
    width: 100%;
    margin-left: 0 !important;
  }
  .student-list {
    width: 100%;
  }
  .seatmap-main {
    flex-direction: column;
    gap: 12px;
    margin: 16px 0 0 0;
    align-items: center;
  }
  .seatmap-side {
    gap: 4px;
  }
  .seat-row {
    gap: 4px;
  }
  .student-btn {
    width: 38px;
    height: 28px;
    font-size: 0.7rem;
    padding: 0;
  }
  .platform-box {
    padding: 6px 10px;
    font-size: 0.9rem;
    margin: 16px auto 0 auto;
  }
  .el-dialog {
    width: 98vw !important;
    min-width: unset !important;
    max-width: 100vw !important;
  }
  .el-table {
    display: block;
    overflow-x: auto;
    width: 100%;
    font-size: 12px;
  }
  .record-search-bar {
    flex-direction: column;
    gap: 4px;
    align-items: stretch;
  }
  .record-search-input {
    width: 100% !important;
  }
}
</style> 